import { components } from "@/lib/ApiSchema";
import $api from "@/lib/queries/openapi";
import { useQueryClient } from "@tanstack/react-query";

export default function useResetLineItems(
  quoteRevisionId: string | undefined,
  teamSlug: string | undefined,
  onSuccess: (apiLineItems: components["schemas"]["LineItemSchema"][]) => void,
  onError: () => void,
) {
  const queryClient = useQueryClient();

  const { mutate } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/quote_revisions/{id}/reset_line_items",
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries({
          queryKey: [
            "get",
            "/api/teams/{team_slug}/quote_revisions/{id}/line_items",
          ],
        });
        onSuccess(data);
      },
      onError,
    },
  );

  return () => {
    if (quoteRevisionId && teamSlug) {
      mutate({
        params: {
          path: {
            team_slug: teamSlug!,
            id: quoteRevisionId,
          },
        },
      });
    }
  };
}
